<template>
    <div>
        <h3>小説を追加する</h3>
        <div>
            <p>
                小説は、タイトルや紹介文、レーティング情報などを含んだ「小説情報」に、
                １つ以上の「本文」を追加することで公開できるようになります。
            </p>
            <h4>小説の新規投稿</h4>
            <p>
                マイページの「小説の新規投稿」あるいは、小説管理＞小説を投稿する、から小説の新規追加画面を開いてください。
            </p>
            <ol>
                <li>タイトル</li>
                <li>紹介文</li>
                <li>長編・短編</li>
            </ol>
            <img src="/img/help/novel/01.png" alt="小説の新規追加" class="img-thumbnail">
            <p>
                最低限、上記３項目さえ登録すれば、小説の登録ができます。<br>
                「ジャンル・タグ・レーティング・表紙」のメニューをクリックすると、追加設定できる項目が開きます。
                ここは後で設定しても構いません。<br>
                小説を追加したら、すぐに本文の執筆を開始できます。
            </p>
            <h4>小説情報</h4>
            <p>
                小説情報を適切に設定することで、読者にどのような小説かをわかりやすく説明することができます。
            </p>
            <h5>タイトルとサブタイトル</h5>
            <p>
                タイトルには小説のタイトルを入力してください。
                タイトルはあまり長いと省略されてしまったり、一部のレイアウトが崩れる原因になります。
                タイトルはルビに対応しています。
            </p>
            <p>
                サブタイトルには小説のサブタイトルを入力してください。これはシリーズ名ではありません。
                サブタイトルはタイトルが長い小説登録のために用意されています。
                外部投稿サイトと連携する場合、サブタイトルも含めたタイトルで連携されます。
            </p>
            <h5>紹介文</h5>
            <p>
                小説の紹介文です。
                未読の読者がどのような小説か、一話目を読みたいかどうかを決めるための部分になります。
            </p>
            <h5>長編・短編</h5>
            <p>
                長編は文字数に関わらず、複数の本文を追加することができます。
                短編は文字数に関わらず、本文を１話しか追加できず、１話完結となります。
                目次が表示されず、直接本文を表示します。
            </p>
            <h5>タグ</h5>
            <p>
                タグは小説を説明するために有益な情報を読者に与え、検索対象となります。
                タグは１５個まで登録することができます。
                タグによる検索にも対応しています。
            </p>
            <h5>セルフレーティング</h5>
            <p>
                作品のレーティングを設定してください。
                適切にレーティング設定されていない場合は、強制的に変更されることがあります。
            </p>
            <h5>コンテンツ</h5>
            <p>
                小説に含まれる表現のうち、読者に注意を促す必要のあるものです。
            </p>
            <h5>公開範囲</h5>
            <div class="table-responsive">
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th>表示</th>
                            <th>ポータル</th>
                            <th>検索結果</th>
                            <th>作品一覧</th>
                            <th>本棚</th>
                            <th>URL直</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="table-primary">
                            <td>公開する</td>
                            <td>○</td>
                            <td>○</td>
                            <td>○</td>
                            <td>○</td>
                            <td>○</td>
                        </tr>
                        <tr class="table-secondary">
                            <td>本棚専用</td>
                            <td>×</td>
                            <td>×</td>
                            <td>×</td>
                            <td>○</td>
                            <td>○</td>
                        </tr>
                        <tr class="table-warning">
                            <td>非公開</td>
                            <td>×</td>
                            <td>×</td>
                            <td>×</td>
                            <td>×</td>
                            <td>○</td>
                        </tr>
                        <tr class="table-danger">
                            <td>保留</td>
                            <td>×</td>
                            <td>×</td>
                            <td>×</td>
                            <td>×</td>
                            <td>×</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p>
                貸し本棚のトップ画面、及び作品一覧、検索結果に表示するかどうかを選択することができます。
                通常は「公開」を選択してください。<br>
                作者の本棚ページだけに掲載したい作品は「本棚専用」を選択します。
                「非公開」にしたものは、公開日を設定すれば、小説ページのURLから読むことができます。
                公開前のプレビューを行いたい場合に便利です。<br>
                「保留」を選択した場合、その小説は編集することはできますが、公開日を設定してもどこにも表示されません。
                保留作品は、「梗概だけ書いたけどまだ執筆しない」や「過去にエタったけどまた再開するつもり」などの作品に使えます。
                保留作品は小説管理ページで「保留」のタブに振り分けられます。
            </p>
            <h5>ジャンル</h5>
            <p>
                多くの作品を抱える多作な作者である場合、掲載する作品をご自身の考えるジャンルで分類することができます。
                ジャンルは最大５つまで追加することができます。
            </p>
            <h5>メールバックアップ</h5>
            <p>
                24時間以内に小説情報、あるいは本文が更新された場合、
                １日１回、作品のZIPアーカイブをご登録メールアドレスに添付ファイルとして送信します。<br>
                詳しくは「<router-link to="/help/novel/backup">メールバックアップする</router-link>」を参照してください。
            </p>
            <h5>表紙</h5>
            <p>
                表紙画像を登録することができます。
                表紙画像は1:1.41のアスペクト比（文庫本サイズ）で、jpgかpng形式で、3MB以内でなければなりません。
                このアスペクト比以外の画像はトリミングされます。<br>
                表紙画像を簡単に作成したい方は、
                <a href="https://sscard.monokakitools.net/covermaker.html" target="_blank">
                    かんたん表紙メーカー
                    <i class="fas fa-external-link-alt"></i>
                </a>をお勧めします。
            </p>
            <p>
                アップロードされた表紙画像はwebp形式に変換され、規定の最大サイズを超えるものは縮小されます。
                オリジナルの画像は保持されません。また、メールバックアップやバックアップデータのダウンロードに表紙画像は含まれません。
            </p>
            <p>
                画像のアップロードに失敗する場合は、ファイル形式がjpg/pngか、3MB以内か、8bit pngではないかを確認してください。
                png画像が8bitかどうか確認できない場合は、その画像をjpgに変換してアップロードを試行してください。
            </p>
            <p>
                表紙画像を登録しない場合でも、作品がどこかに表示されるたびに、ランダムな表紙画像が生成されます。
                この画像は選べません。
            </p>
            <h5>リンクバナー</h5>
            <p>
                小説専用の伝統的リンクバナーを設定することができます。
                200px x 40pxの画像を設定し、小説サーチサイトへの作品登録時に使用してください。
                リンク先の仕様に応じて、400px x 80pxの画像も登録できます。
            </p>
            <h5>電子書籍</h5>
            <p>
                完結作品は電子書籍として自動的にダウンロード可能になります。
                電子書籍を出力しない設定にすることで、完結作品でも電子書籍のダウンロードを無効に設定できます。
            </p>
            <p>
                電子書籍を出力しない設定にしても、作者自身は「全文ダウンロード」項目から電子書籍をダウンロードできます。
                これは電子書籍のレイアウト確認用で、連載中でも出力することが可能です。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "小説を追加する | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>